import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import { CourseService, getAllCourses } from '../services/courseService'
import type {
  CourseCreateRequest,
  CourseQueryParams,
  CourseUpdateRequest,
} from '../services/courseService'

// 查询所有课程（下拉选择使用）
export function useAllCourses() {
  return useQuery({
    queryKey: ['courses', 'all'],
    queryFn: getAllCourses,
    select: (data) => data.data,
  })
}

// 查询课程列表（分页）
export function useCourses(params: CourseQueryParams) {
  return useQuery({
    queryKey: ['courses', 'list', params],
    queryFn: () => CourseService.queryCourses(params),
    select: (data) => ({
      records: data.data.records, // 更新为分页查询的记录
      total: data.data.total, // 总数
      current: data.data.current, // 当前页码
      size: data.data.size, // 每页大小
    }),
  })
}

// 创建课程
export function useCreateCourse(
  onSuccessCallback?: (courseName: string) => void,
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CourseCreateRequest) => CourseService.createCourse(data),
    onSuccess: (_, variables) => {
      message.success('课程创建成功')
      queryClient.invalidateQueries({ queryKey: ['courses'] })

      // 调用回调函数，传入新创建的课程名称
      if (onSuccessCallback && variables.name) {
        onSuccessCallback(variables.name)
      }
    },
    onError: (error: Error) => {
      message.error(`创建失败: ${error.message}`)
    },
  })
}

// 更新课程
export function useUpdateCourse() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CourseUpdateRequest) => CourseService.updateCourse(data),
    onSuccess: () => {
      message.success('课程更新成功')
      queryClient.invalidateQueries({ queryKey: ['courses'] })
    },
    onError: (error: Error) => {
      message.error(`更新失败: ${error.message}`)
    },
  })
}

// 删除课程
export function useDeleteCourse() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (courseId: number) => CourseService.deleteCourse(courseId),
    onSuccess: () => {
      message.success('课程删除成功')
      queryClient.invalidateQueries({ queryKey: ['courses'] })
    },
    onError: (error: Error) => {
      message.error(`删除失败: ${error.message}`)
    },
  })
}
